module.exports = __webpack_public_path__ + "static/media/side-strip.0acfc571.png";